import React from 'react';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';
import { useTranslation } from '@common/hooks/useTranslation';
import { jobTypeRules } from '../../rules/jobType';
import { JobTypeRadioField } from './JobTypeRadioField';

type JobTypeProps<T extends FieldValues> = UseControllerProps<T> & {
  overrides?: {
    label?: string;
  };
};

export function JobType<T extends FieldValues>({
  name,
  control,
  overrides
}: JobTypeProps<T>) {
  const { t } = useTranslation();

  return (
    <Controller
      name={name}
      control={control}
      rules={jobTypeRules(t)}
      render={({ field: { onChange, value }, formState }) => (
        <JobTypeRadioField
          onChange={onChange}
          label={overrides?.label}
          value={value}
          error={formState?.errors[name]?.message as string}
        />
      )}
    />
  );
}
